(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('RegisterPageController', RegisterPageController);

    RegisterPageController.$inject = ['User', "$state", "AlertService", '$window', '$uibModal'];

    function RegisterPageController(User, $state, AlertService, $window, $uibModal) {
        var vm = this;
        var termsUrl = "./content/terms-privacy/terms-conditions.pdf";
        var privacyUrl = "./content/terms-privacy/privacy.pdf";
        vm.checkTerms = false;
        vm.checkPrivacy = false;
        vm.check1 = false;

        vm.save = function () {
            User.create(vm.user, onSaveSuccess, onSaveError);

            function onSaveSuccess() {
                AlertService.success("Domain and User Created, check your email");
                $state.go("login")
            }

            function onSaveError(error) {
                console.log(error)
            }
        };

        vm.termsAgree = function() {
            $window.open(termsUrl);
            vm.checkTerms = true;
        };

        vm.privacyAgree = function() {
            $window.open(privacyUrl);
            vm.checkPrivacy = true;
        };

        vm.openModal = function (){
            if (!vm.checkPrivacy || !vm.checkTerms) {
                document.getElementById("field_check1").checked = false;
                $uibModal.open({
                    templateUrl: 'app/components/register-page/privacy-terms-modal.html',
                    controller: 'ModalTermsController',
                    controllerAs: 'vm',
                    size: 'md',
                    backdrop: 'static',
                    resolve: {
                        privacy: function (){
                            return vm.checkPrivacy;
                        },
                        terms: function (){
                            return vm.checkTerms;
                        }
                    },
                }).result.then(function(result){
                    vm.checkPrivacy = result.privacy;
                    vm.checkTerms = result.terms;
                })
            }

        }
    }
})();
